module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"karana":" karana","karana1":"Bava","karana2":"Balava","karana3":"Kaulava","karana4":"Taitila","karana5":"Gara","karana6":"Vanija","karana7":"Vishti","karana8":"Shakuni","karana9":"Chatushpada","karana10":"Naga","karana11":"Kinstughana","diety":"Diety"}}')
  delete Component.options._Ctor
}
